import React from 'react'
import Textarea from '@cloudscape-design/components-themed/textarea'

// https://cloudscape.design/components/textarea
export function RadTextarea ({ ...rest }) {
  return (
    <Textarea {...rest} />
  )
}
